module.exports = __webpack_public_path__ + "img/cheatsheet_icon_reputation_2x.006ceaca.png";